<script lang="ts">
import { AppBreadcrumbs } from "./app-breadcrumbs";
export default AppBreadcrumbs;
</script>
<style scoped>
.p-breadcrumb {
    background-color: transparent;
    border: none;
    padding-left: 0;
}
</style>
<template>
    <Breadcrumb :home="breadCrumbsHome" :model="breadCrumbsItems">
        <template #item="{ item, props }">
            <router-link
                v-if="item?.route && item?.level != breadCrumbsLevel"
                v-slot="{ href, navigate }"
                :to="item?.route"
                custom
            >
                <a :href="href" v-bind="props?.action" @click="navigate">
                    <span class="text-primary font-semibold">
                        {{ item.label }}
                    </span>
                </a>
            </router-link>
            <span v-else class="text-color">{{ item.label }}</span>
        </template>
    </Breadcrumb>
</template>
